/*  Copyright 2024 Sebastian Spautz

    This file is part of "AiS Online Forms".

    "AiS Online Forms" is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    any later version.
    This program is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.
    You should have received a copy of the GNU General Public License
    along with this program.  If not, see http://www.gnu.org/licenses/.
*/

/**
  * Modul for localization.
  * @module acesinspace.localization
*/

const i18n = {
    updateConfirmation: [
        "Update now?", {
            de: "Jetzt aktualisieren?"
        }
    ]
}

export default function localize(key) {
    return i18n[key][1][document.documentElement.lang] ?? i18n[key][0]
}
